// extracted by mini-css-extract-plugin
export default {"element":"Service_element__Q6yvi","image":"Service_image__qyINm"};